module.exports = __webpack_public_path__ + "img/icon-component-lanel_BookFlowerHouse.a89d0695.svg";